export { default } from './BancoAutoPesado';
